import React from "react";
import { UtilsService } from "../../services/utils";
import { Link } from "react-router-dom";

function GeneralTable({ list }: any) {
  const getStatus = (row: any) => {
    if (row.packing) {
      return "Pagos";
    }

    const valorTotal = row.customers.reduce(
      (acc: number, c: any) => acc + c.valor_total,
      0
    );
    if (!valorTotal) {
      return "Empaque";
    }

    return "General";
  };

  return (
    <table
      className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
      id="kt_table_users"
    >
      <thead>
        <tr
          className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
          role="row"
        >
          <th
            aria-label="Role: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="">Fecha de creación</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Fecha</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Procedencia</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Productores</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Folio de pesada</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Empaque</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">No. de cajas</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Peso neto</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Peso por caja</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Valor total</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Total pagado</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Total adeudado</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Estatus</span>
            <span className="dt-column-order" />
          </th>
          <th className="min-w-125px " colSpan={1} rowSpan={1} tabIndex={0}>
            <span className="">Acciones</span>
            <span className="dt-column-order" />
          </th>
        </tr>
      </thead>
      <tbody className="text-gray-600 fw-semibold">
        {list.map((row: any) => (
          <tr key={row._id}>
            <td>{UtilsService.dateFormat(row.created_at)}</td>
            <td>{UtilsService.dateFormat(row.general.date, "DD/MM/YYYY")}</td>
            <td>{row.general.procedencia}</td>
            <td>
              {row.customers.map((customer: any) => (
                <p key={customer._id} className="nowrap mb-0">
                  {customer.customer.name}: {customer.field.name}
                </p>
              ))}
            </td>
            <td>{row.general.folio_pesada}</td>
            <td>{row.general.packing.name}</td>
            <td>{row.general.total_cajas}</td>
            <td>{row.general.peso_neto}</td>
            <td>{row.general.peso_caja}</td>
            <td>$ {UtilsService.numberFormat(row.valorTotal)}</td>
            <td>$ {UtilsService.numberFormat(row.totalPayments)}</td>
            <td>$ {UtilsService.numberFormat(row.totalDue)}</td>
            <td>{getStatus(row)}</td>
            <td className="">
              <button
                className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-trigger="click"
              >
                Editar
                <i className="ki-duotone ki-down fs-5 ms-1" />
              </button>
              <div
                className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                data-kt-menu="true"
              >
                <div className="menu-item px-3">
                  <Link
                    to="/register/form"
                    className="menu-link px-3 text-start"
                    state={{ corte: row, step: 1 }}
                  >
                    General
                  </Link>
                  {(getStatus(row) === "Empaque" || getStatus(row) === "Pagos") && (
                    <Link
                      to="/register/form"
                      className="menu-link px-3 text-start"
                      state={{ corte: row, step: 2 }}
                    >
                      Empaque
                    </Link>
                  )}
                  {getStatus(row) === "Pagos" && (
                    <Link
                      to="/register/form"
                      className="menu-link px-3 text-start"
                      state={{ corte: row, step: 3 }}
                    >
                      Pagos
                    </Link>
                  )}
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot />
    </table>
  );
}

export default GeneralTable;
